import parsePhoneNumber, { isValidPhoneNumber } from 'libphonenumber-js';
import { z } from 'zod';

export const zPhone = z
  .string()
  .min(1, 'Phone number is required.')
  .refine((value) => isValidPhoneNumber(value, 'AU'), 'Invalid phone number.')
  .transform((value) => {
    const parsed = parsePhoneNumber(value, { defaultCountry: 'AU', extract: false })?.number;
    return parsed || value;
  });

export type ZPhoneType = z.infer<typeof zPhone>;
